module.exports = __webpack_public_path__ + "img/SURVEY_HAPPINESS.edf78bc0.png";